import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top on forward navigation (not back button)
    // This works because back button navigation doesn't trigger this effect reliably
    console.log('Location changed, scrolling to top:', location.pathname);
    
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [location]);

  return null;
}

export default ScrollToTop;
